import { FormikErrors } from 'formik';

export function flattenErrorPaths(errors: FormikErrors<unknown>, prefix = ''): string[] {
  if (!errors || typeof errors !== 'object') {
    return prefix ? [prefix] : [];
  }

  return Object.entries(errors).flatMap(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      return flattenErrorPaths(value as FormikErrors<unknown>, path);
    }
    return [path];
  });
}

function nestTouchedPaths(paths: string[]): Record<string, unknown> {
  const touched: Record<string, unknown> = {};
  for (const path of paths) {
    const keys = path.split('.');
    let current = touched;
    for (let index = 0; index < keys.length; index += 1) {
      const key = keys[index]!;
      if (index === keys.length - 1) {
        current[key] = true;
        continue;
      }
      const next = current[key];
      if (typeof next !== 'object' || next === null || next === true) {
        current[key] = {};
      }
      current = current[key] as Record<string, unknown>;
    }
  }
  return touched;
}

export function touchAllErrorPaths(
  setTouched: (fields: Record<string, unknown>, shouldValidate?: boolean) => void,
  errors: FormikErrors<unknown>,
) {
  const paths = flattenErrorPaths(errors);
  if (paths.length === 0) {
    return;
  }
  setTouched(nestTouchedPaths(paths), false);
}
